import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=970d3e10&scoped=true&"
import script from "./SetPassword.vue?vue&type=script&lang=js&"
export * from "./SetPassword.vue?vue&type=script&lang=js&"
import style0 from "./SetPassword.vue?vue&type=style&index=0&id=970d3e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970d3e10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInputPassword: require('/workspace/components/Form/FormInputPassword.vue').default,FormInput: require('/workspace/components/Form/FormInput.vue').default,Card: require('/workspace/components/Card.vue').default})
